import { Component, Input } from '@angular/core';

@Component({
  selector: 'nobis-required-element',
  templateUrl: './required-element.component.html',
  styleUrls: ['./required-element.component.scss']
})
export class RequiredElementComponent {
  @Input() status: 0 | 1 | 2 = 1;
  /** Oculta el texto del estado y deja solo el ícono */
  @Input() iconOnly = false;

  protected get color() {
    return this.status === 1 ? '#E45454' : '#52B7A0';
  }

  protected get message(): string {
    const map: Record<number, string> = {
      0: 'RECOMENDABLE',
      1: 'OBLIGATORIO',
      2: 'SOLO SI CORRESPONDE'
    }
    return map[this.status] || 'OBLIGATORIO';
  }
}
